import { createSlice } from '@reduxjs/toolkit'


const initialState = {
    enquiry_form: null,
    i_form: null,
    rework: null,
    controller: {
        calendar_type: null,
        calender_team_list: null,
        calender_status_list: null
    }
}

export const appDataSlice = createSlice({
    name: 'appData',
    initialState,
    reducers: {

        //? Enquiry
        initialStartEnquiry: (state, action) => {
            state.enquiry_form = {
                prospect_id: action.payload?.prospect_id,
                enquiry_id: action.payload?.enquiry_id,
                bucket_id: action.payload?.bucket_id,
                date: action.payload?.date,
                in_time: action.payload?.in_time ? new Date(action.payload?.in_time).toISOString() : null,
                out_time: null
            }
        },
        stopEnquiry: (state) => {
            state.enquiry_form = null
        },
        updateEnquiryForm: (state, action) => {
            state.enquiry_form = {
                ...state.enquiry_form,
                ...action.payload
            }
        },
        submitEnquiryForm: (state, action) => {
            let { prospect_id, enquiry_id, bucket_id, date, in_time, out_time, ...formData } = state.enquiry_form

            formData = {}

            if (in_time) {
                state.enquiry_form = {
                    prospect_id: prospect_id,
                    enquiry_id: enquiry_id,
                    bucket_id: bucket_id,
                    date: date,
                    in_time: in_time,
                    out_time: null,
                    ...formData
                }
            } else {
                state.enquiry_form = null
            }
        },
        clearEnquiryForm: (state, action) => {
            state.enquiry_form = {
                prospect_id: state.enquiry_form?.prospect_id,
                enquiry_id: state.enquiry_form?.enquiry_id,
                bucket_id: state.enquiry_form?.bucket_id,
                date: state.enquiry_form?.date,
                in_time: state.enquiry_form?.in_time,
                out_time: null
            }
        },
        completeEnquiry: (state, action) => {
            state.enquiry_form = null
        },

        //? Installation
        initialStartInstallation: (state, action) => {
            state.i_form = {
                prospect_id: action.payload?.prospect_id,
                installation_id: action.payload?.installation_id,
                bucket_id: action.payload?.bucket_id,
                date: action.payload?.date,
                in_time: action.payload?.in_time ? new Date(action.payload?.in_time) : null,
                out_time: null
            }
        },
        stopInstallation: (state) => {
            state.i_form = null
        },
        updateInstallationForm: (state, action) => {
            state.i_form = {
                ...state.i_form,
                ...action.payload
            }
        },
        clearInstallationForm: (state, action) => {
            state.i_form = null
        },

        //? rework
        initialStartRework: (state, action) => {
            state.rework = {
                ...action.payload,
                in_time: new Date().toISOString(),
                out_time: null

            }
        },
        updateReworkForm: (state, action) => {
            state.rework = {
                ...state.rework,
                ...action.payload
            }
        },
        clearReworkForm: (state, action) => {
            state.rework = null
        },

        //? Controller - Calender
        updateController: (state, action) => {
            state.controller = {
                ...state?.controller,
                ...action?.payload
            }
        }
    }
})


export const {
    initialStartEnquiry, stopEnquiry, updateEnquiryForm, submitEnquiryForm, clearEnquiryForm, completeEnquiry,
    initialStartInstallation, stopInstallation, updateInstallationForm, clearInstallationForm,
    initialStartRework, clearReworkForm, updateReworkForm, updateController
} = appDataSlice.actions;
export default appDataSlice.reducer